import type { MonthlyNetSalesReport } from 'model/MonthlyNetSalesReport';

export type MonthlyNetSalesReportState = {
    loading: boolean;
    report: MonthlyNetSalesReport;
};

export const emptyMonthlyNetSalesReport: MonthlyNetSalesReport = {
    year: 0,
    range: { start: '', end: '' },
    refunds: {
        byMonth: [],
        yearTotal: 0
    },
    rows: []
};

export const initialMonthlyNetSalesReportState: MonthlyNetSalesReportState = {
    loading: false,
    report: emptyMonthlyNetSalesReport
};
